import type { PropsCoreState } from '~/store/interfaces';

export const selectRecovery = ({ recovery }: PropsCoreState) => recovery;
